import {
  isInvestorBasicInformationComplete,
  isInvestorQualificationComplete,
  isInvestorFundQualificationComplete,
  isInvestorAccreditationComplete,
  isInvestorAffiliationsComplete,
  isInvestorPreferencesComplete,
} from 'entoro-shared';
import { indexOf } from 'lodash';

export const accountCompletionValidators = {
  '/account/basic-information': isInvestorBasicInformationComplete,

  '/account/qualification': (investorUser) =>
    Boolean(
      investorUser.selectedOptionTypes && investorUser.intendInvestingFunds
    ),

  '/account/suitability': (investorUser) => Boolean(investorUser.suitability),

  '/account/affiliations': isInvestorAffiliationsComplete,

  '/account/preferences': isInvestorPreferencesComplete,

  '/account/verification': isInvestorAccreditationComplete,
};

const offerVisibilityValidators = {
  '/account/basic-information': isInvestorBasicInformationComplete,

  '/account/qualification': (investorUser) =>
    Boolean(
      investorUser.selectedOptionTypes && investorUser.intendInvestingFunds
    ),

  '/account/suitability': (investorUser) => Boolean(investorUser.suitability),
};

export const getAccountRouteToComplete = (investorUser) =>
  Object.keys(offerVisibilityValidators).find(
    (validator) => !offerVisibilityValidators[validator](investorUser)
  );

export const getNextOnboardingRoute = ({ investorUser, location }) => {
  const { pathname: currentRoute } = location;

  const accountRoutes = Object.keys(accountCompletionValidators);

  const numRoutes = accountRoutes.length;

  const currentIndex = indexOf(accountRoutes, currentRoute);

  // If on the last onboarding route, start validating routes from the beginning
  const startIndex = currentIndex === numRoutes - 1 ? 0 : currentIndex;

  // Remove previous routes; we only want to check the next routes
  const routesToCheck = accountRoutes.slice(startIndex, numRoutes + 1);

  const nextOnboardingRoute = routesToCheck.find(
    (route) =>
      route !== currentRoute &&
      !accountCompletionValidators[route](investorUser)
  );

  return nextOnboardingRoute;
};



// WEBPACK FOOTER //
// ./src/components/Account/accountCompletionValidators.js